import { Moment } from 'moment';
import PlannerCalendarEvent from './PlannerCalendarEvent';
import { Month } from './common';

export default class PlannerCalendar {
  month: Month | null = null;
  year: number | null = null;
  events: Array<PlannerCalendarEvent> = [];
  closeDayFrom: Moment | null = null;
}
